module.exports = __webpack_public_path__ + "img/forgot-password.1218de22.png";